import React from 'react';

import { useStore } from '@/store';
import { formatDateWithRelativeLabels } from '@/utils/date';

interface FormattedDateRelativeProps {
  /** ISO date string to format */
  value: string | undefined;
  /** Optional className for the span */
  className?: string;
}

/**
 * Component that displays a formatted date with relative labels (Today, Yesterday, etc.)
 * in the user's selected timezone.
 * Automatically subscribes to timezone changes from the store.
 *
 * Output format: "Today", "Yesterday", or "Dec 25, 2024"
 */
export const FormattedDateRelative: React.FC<FormattedDateRelativeProps> = React.memo(
  ({ value, className }) => {
    const { getTimeZone } = useStore();
    const timeZone = getTimeZone();
    return <span className={className}>{formatDateWithRelativeLabels(value, timeZone)}</span>;
  },
);
FormattedDateRelative.displayName = 'FormattedDateRelative';
